import { Shipyard } from 'icreate/common/models/shipyard';
import { ProjectStatus } from 'icreate/common/models/vessel';

export const shipyardList = [
    {
        id: '1',
        name: 'Shipyard 1',
        vessels: [
            {
                name: 'Vessel 1',
                id: '1',
                numberOps: 3,
                numberFcu: 1,
                shipyardId: '1',
                locked: false,
                projectStatus: ProjectStatus.undefined,
            },
            {
                name: 'Vessel 2',
                id: '2',
                numberOps: 5,
                numberFcu: 2,
                shipyardId: '1',
                locked: false,
                projectStatus: 'Undefined',
            },
        ],
    },
    {
        id: '2',
        name: 'Shipyard 2',
        vessels: [
            {
                name: 'Vessel 11',
                id: '11',
                numberOps: 10,
                numberFcu: 4,
                shipyardId: '1',
                locked: false,
                projectStatus: 'Undefined',
            },
        ],
    },
] as Shipyard[];
